import PropTypes from "prop-types"
import React, { useRef, useEffect } from "react"
import "./header.scss"
import { Link } from "gatsby"
import Menudesktop from "./../desktopmenu/menudesktop"
import { gsap, Power3 } from "gsap"

const Header = ({ siteTitle }) => {
  const letter = useRef(null)
  const button = useRef(null)

  useEffect(() => {
    gsap.to(
      letter.current,
      2,
      {
        opacity: 1,
        x: 0,
        ease: Power3.easeIn,
      },
      0
    )

    gsap.to(
      button.current,
      2,
      {
        opacity: 1,
        delay: 2,
        ease: Power3.easeOut,
      },
      0
    )
  }, [])

  return (
    <header className="header">
      <div className="header__container container">
        <Link
          to="/"
          className="header__title no-select"
          ref={letter}
          tabIndex="1"
        >
          {siteTitle}
        </Link>

        <div className="header__options">
          <Menudesktop />

          <button className="btn__cv no-select" ref={button} tabIndex="6">
            Download CV
          </button>
        </div>
      </div>
    </header>
  )
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
